<template>
    <v-container fluid fill-height>
        <Headful title="Wachtwoord vergeten"></Headful>
        <Header
            color="white"
            show-back-button
            show-logo
            :dark="false"
            extended
        ></Header>
        <v-layout align-center justify-center>
            <v-flex>
                <v-form ref="form" @submit.prevent="requestPasswordReset" class="px-5">
                    <v-card class="elevation-0">
                        <v-card-text class="pa-7">
                            <h1 class="text-h5 mb-5 text-center text--success">Wachtwoord vergeten?</h1>
                            <p class="text-center mb-5">Vul hieronder je e-mailadres in. Je ontvangt dan een e-mail om je wachtwoord opnieuw in te stellen.</p>
                            <v-text-field
                                v-if="!submitted"
                                type="text"
                                outlined
                                rounded
                                hide-details="auto"
                                single-line
                                v-model="username"
                                label="E-mailadres"
                                :loading="submitting"
                                :rules="usernameRules"
                                required
                                class="mb-5"
                            ></v-text-field>
                            <v-alert color="success" dark v-if="submitted" class="mb-5">
                                Als er al een account voor dit e-mailadres bestaat, dan ontvang je een e-mail met verdere instructies om je wachtwoord te resetten.
                            </v-alert>
                            <v-btn type="submit" color="primary" rounded v-if="!submitted" :loading="submitting" :disabled="submitting || username.length < 1" block class="mb-2 elevation-0">Wachtwoord resetten</v-btn>
                            <v-btn :to="{name: 'SignIn'}" block outlined rounded color="secondary" class="elevation-0">Terug naar inloggen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Header from "../../components/layout/Header";
import Headful from "@/components/layout/Headful";

export default {
    name: "ForgotPassword",
    components: {
        Headful,
        Header,
    },
    data: () => ({
        username: '',
        usernameRules: [
            v => !!v || 'E-mailadres is verplicht'
        ],
        submitted: false,
        submitting: false,
    }),
    methods: {
        back () {
            if (window.history.length > 2) {
                this.$router.go(-1);
            } else {
                this.$router.push({name: 'Login'});
            }
        },
        requestPasswordReset () {
            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitted) {
                return;
            }

            this.submitting = true;

            // Submit data to auth store
            this.$store.dispatch('forgotPassword', {
                username: this.username,
            }).then(() => {
                this.submitted = true;
                return this.$store.dispatch('showSnackbar', { color: 'success', text: 'Wachtwoord reset link verzonden'});
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Serverfout, neem contact op' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
